import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import Teambuilding from './components/Teambuilding';
import Transfers from './components/Transfers';
import Lessons from './components/Lessons';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import { VideoSupportProvider } from "./contexts/BrowserContext";
import CookieBot from 'react-cookiebot';
import Analytics from './services/googleanalytics';
import Packages from './components/Packages';

function App() {
  const cookiebotId = '3c189478-40da-45b9-83ad-9075e9370c0d';
  return (
    <VideoSupportProvider>
      <div className="App" id="top">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/teambuilding" element={<Teambuilding />} />
            <Route path="/transfers" element={<Transfers />} />
            <Route path="/lessons" element={<Lessons />} />
            <Route path="/packages" element={<Packages />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <CookieBot domainGroupId={cookiebotId} />
        <Analytics />
      </div>
    </VideoSupportProvider>
  );
}

export default App;